import "../../App.css";
import { FaSignInAlt } from "react-icons/fa";
import { IoSearch } from "react-icons/io5";
import { FaSearchPlus } from "react-icons/fa";
import { IoMdClose } from "react-icons/io";
import { useEffect, useRef, useState } from "react";
import { Modal } from "antd";
import { FaUser } from "react-icons/fa";
import { Link, useNavigate } from "react-router-dom";
import { useLocation } from "react-router-dom";
import { IoMdArrowDropdown } from "react-icons/io";
import OpenBets from "../openbets";
import Appconfig from "../../config/config";
import axios from "axios";
import "react-notifications/lib/notifications.css";
import {
  NotificationContainer,
  NotificationManager,
} from "react-notifications";
import { useSelector, useDispatch } from "react-redux";
import {
  getAllBets,
  emptyOpenBets,
} from "../../redux/slice/openBet/openBetSlice";
import { emptyUserInfo } from "../../redux/slice/userInfo/userInfoSlice";
import OpenRules from "components/openRules/rules";
import { setUserInfo } from "../../redux/slice/userInfo/userInfoSlice";
import { emptyBalance } from "../../redux/slice/user/userSlice";
import { emptyLoingUserData } from "../../redux/slice/userData/userDataSlice";
import UserAutoLogout from "components/userAutoLogout";
import { getLogoByDomain } from "utils/domainConfig";
import { useLoginLogic } from "hooks/useLoginLogic";

function Header() {
  // Use the SAME logic hook here
  const userInfos = useSelector((state) => state.bets); // Use selector to access state
  const betData = useSelector((state) => state.data); // Use selector to access state
  const userInfo = useSelector((state) => state?.userInfo?.userdata); // get login user details
  UserAutoLogout(); // Auto logout after 2 hours

  const dispatch = useDispatch();
  const [balance, setBalance] = useState(0);
  const [exposure, setExposure] = useState(0);
  // const balance = userbalance?.balance;
  // const exposure = userbalance?.exposure;
  const [headerChange, setHeaderChange] = useState(false);
  const [balanceWithExp, setbalanceWithExp] = useState(0);

  const [captchaValue, setCaptchaValue] = useState("");
  const [captchaInput, setCaptchaInput] = useState("");
  const [captchaValidationError, setCaptchaValidationError] = useState("");

  const [time, setTime] = useState("");

  useEffect(() => {
    const updateTime = () => {
      const now = new Date().toLocaleString("en-IN", {
        timeZone: "Asia/Kolkata",
        hour: "2-digit",
        minute: "2-digit",
        second: "2-digit",
      });
      setTime(now);
    };

    updateTime(); // Initial call
    const interval = setInterval(updateTime, 1000);

    return () => clearInterval(interval);
  }, []);

  const generateCaptcha = () => {
    const num = Math.floor(1000 + Math.random() * 9000); // 4 digits
    setCaptchaValue(num.toString());
  };
  useEffect(() => {
    generateCaptcha();
  }, []);

  // let balanceWithExp = balance - Math.abs(exposure);
  // const navItems = [
  //   {
  //     title: "Home",
  //     url: "/",
  //   },
  //   {
  //     title: "In-Play",
  //     url: "/inplay",
  //   },
  //   {
  //     title: "Multi Markets",
  //     url: "/multimarket",
  //   },
  //   {
  //     title: "Cricket",
  //     url: "/allsport-highlight/4",
  //   },
  //   {
  //     title: "Tennis",
  //     url: "/allsport-highlight/2",
  //   },
  //   {
  //     title: "Soccer",
  //     url: "/allsport-highlight/1",
  //   },
  //   {
  //     title: "Horse Racing",
  //     url: "/allsport-highlight/7",
  //   },
  //   {
  //     title: "Greyhound Racing",
  //     url: "/allsport-highlight/4339",
  //   },
  //   {
  //     title: "Politics",
  //     url: "/allsport-highlight/2378961",
  //   },
  //   {
  //     title: "Lottery",
  //     url: "/allsport-highlight/66104",
  //   },
  //   {
  //     title: "Live Casino",
  //     url: "/live-casino",
  //   },
  //   {
  //     title: "Virtual Sports",
  //     url: "/virtual-sports",
  //   },
  //   {
  //     title: "Tips & Previews",
  //     url: "/tips-previews",
  //   },
  // ];

  const {
    cricket = 0,
    tennis = 0,
    soccer = 0,
    esoccer = 0,
  } = useSelector((state) => state.inplayCounts) || {};

  const navItems = [
    { title: "Home", url: "/" },
    { title: "In-Play", url: "/inplay?tab=today" },
    { title: "Multi Markets", url: "/multimarket" },
    { title: "Cricket", url: "/allsport-highlight/4" },
    { title: "Tennis", url: "/allsport-highlight/2" },
    { title: "Soccer", url: "/allsport-highlight/1" },
    { title: "Virtual Cricket", url: "/allsport-highlight/4" },
    { title: "E-Soccer", url: "/allsport-highlight/1" },
  ];

  const location = useLocation();

  useEffect(() => {
    if (location) {
      let casinoPath = location?.pathname?.split("/")[1];
      if (casinoPath === "casino") {
        setHeaderChange(true);
      } else {
        setHeaderChange(false);
      }
    }
  }, [location]);

  const ref = useRef(null);
  const [showEventInp, setShowEventInp] = useState(false);
  const [ageModalOpen, setAgeModalOpen] = useState(false);
  const [loginModel, setLoginModel] = useState(false);
  const [exposureModal, setExposureModal] = useState(false);

  const [showPassword, setShowPassword] = useState(false);
  const [myAccountListOpen, setMyAccountListOpen] = useState(false);
  const [openbets, setOpenbets] = useState(false);
  const [openRules, setOpenRules] = useState(false);

  // const [openBetShow, setOpenbetShow] = useState([])
  const openBetShow =
    userInfos?.bets?.exposureBets?.length > 0
      ? userInfos?.bets?.exposureBets
      : [];

  const [loadBalance, setLoadBalance] = useState(true);
  const [isDisabled, setIsDisabled] = useState(false);

  const navigate = useNavigate();
  // let pthh = MainBalance - Math.abs(exposure);
  const [user_nameValidationError, setUser_NameValidationError] = useState(
    "Please enter username",
  );
  const [passwordValidationError, setPasswordValidationError] = useState(
    "Please enter password",
  );
  const [validationError, setValidationError] = useState("");

  const [formData, setformData] = useState({
    user_name: "",
    password: "",
    site_code: Appconfig.sitecodes,
    user_type: "User",
  });

  const handleHideDropdown = (event) => {
    if (event.key === "Escape") {
      setMyAccountListOpen(false);
    }
  };

  const handleClickOutside = (event) => {
    if (ref.current && !ref.current.contains(event.target)) {
      setMyAccountListOpen(false);
    }
  };
  useEffect(() => {
    document.addEventListener("keydown", handleHideDropdown, true);
    document.addEventListener("click", handleClickOutside, true);
    return () => {
      document.removeEventListener("keydown", handleHideDropdown, true);
      document.removeEventListener("click", handleClickOutside, true);
    };
  });

  const showAgeModal = () => {
    setAgeModalOpen(true);
  };
  const handleAgeOk = () => {
    setAgeModalOpen(false);
  };
  const handleCancel = () => {
    setAgeModalOpen(false);
  };
  const handleExposureOk = () => {
    setExposureModal(false);
  };
  const handleExposureCancel = () => {
    setExposureModal(false);
  };

  function checkValidation() {
    let errorText;
    if (formData.user_name.trim() === "") {
      setUser_NameValidationError("Please enter username");
      document.querySelector(".username-error").classList.remove("hidden");
    }
    if (formData.password === "") {
      document.querySelector(".password-error").classList.remove("hidden");
      setPasswordValidationError("Please enter password");
    }
    const regex = /^[a-zA-Z0-9]*$/;
    if (!regex.test(formData.user_name)) {
      document.querySelector(".username-error").classList.remove("hidden");
      setUser_NameValidationError("Username is only allow a-z and 0-9.");
      return false;
    }

    setValidationError(errorText);
    if (regex.test(formData.user_name) && formData.password !== "") {
      return true;
    }
    return false;
  }
  const handleInputChange = (event) => {
    setformData({
      ...formData,
      [event.target.name]: event.target.value,
    });
    if (event.target.name === "user_name") {
      document.querySelector(".username-error").classList.add("hidden");
    }
    if (event.target.name === "password") {
      document.querySelector(".password-error").classList.add("hidden");
    }
  };

  //   const handleSubmit = (event) => {
  //     if (checkValidation()) {
  //       setIsDisabled(true);

  //       var config = {
  //         method: "post",
  //         url: `${Appconfig.apiUrl}users/userAuthenticate`,
  //         headers: {
  //           "Content-Type": "application/json",
  //         },

  //         data: JSON.stringify(formData),
  //       };
  //       axios(config)
  //         .then(function (response) {
  //           setIsDisabled(false);

  //           if (response.data.result != 0) {
  //             NotificationManager.success(response.data.resultMessage, "", 3000);
  //             dispatch(setUserInfo(response.data.resultData));
  //             localStorage.setItem("loginTime", new Date().getTime().toString());

  //             // localStorage.setItem('userdata', JSON.stringify(response.data.resultData && response.data.resultData));
  //             localStorage.setItem(
  //               "login_token",
  //               response.data.resultData && response.data.resultData.login_token
  //             );
  //             formData.password = "";
  //             formData.user_name = "";
  //             setTimeout(() => {
  //               navigate("/");
  //             }, 1000);
  //           } else {
  //             setValidationError(response.data.resultMessage);
  //             // errorNotification();
  //             NotificationManager.error("Invalid Login Credential!", "", 3000);
  //           }
  //         })
  //         .catch(function (error) {
  //           setIsDisabled(false);

  //           console.log(error);
  //         });
  //     }
  //   };

  const handleSubmit = (event) => {
    // CAPTCHA check first
    if (captchaInput !== captchaValue) {
      setCaptchaValidationError("Captcha is incorrect");
      NotificationManager.error("Incorrect Captcha!", "", 2000);
      return;
    } else {
      setCaptchaValidationError("");
    }

    // Then your existing validation
    if (checkValidation()) {
      setIsDisabled(true);

      var config = {
        method: "post",
        url: `${Appconfig.apiUrl}users/userAuthenticate`,
        headers: {
          "Content-Type": "application/json",
        },
        data: JSON.stringify(formData),
      };

      axios(config)
        .then(function (response) {
          setIsDisabled(false);

          if (response.data.result != 0) {
            NotificationManager.success(response.data.resultMessage, "", 3000);

            // Reset captcha
            generateCaptcha();
            setCaptchaInput("");

            dispatch(setUserInfo(response.data.resultData));
            localStorage.setItem("loginTime", new Date().getTime().toString());
            localStorage.setItem(
              "login_token",
              response.data.resultData?.login_token,
            );

            formData.password = "";
            formData.user_name = "";

            setTimeout(() => {
              navigate("/");
            }, 1000);
          } else {
            NotificationManager.error("Invalid Login Credential!", "", 3000);

            // Regenerate captcha
            generateCaptcha();
            setCaptchaInput("");
          }
        })
        .catch(function (error) {
          setIsDisabled(false);
          console.log(error);

          generateCaptcha();
          setCaptchaInput("");
        });
    }
  };

  const logout = () => {
    localStorage.removeItem("userdata");
    localStorage.removeItem("login_token");
    localStorage.removeItem("loginTime");
    dispatch(emptyUserInfo());
    dispatch(emptyBalance());
    dispatch(emptyOpenBets());
    dispatch(emptyLoingUserData());
    setMyAccountListOpen(false);

    navigate("/");
  };

  function getBalance() {
    var data = JSON.stringify({
      user_id: userInfo?._id,
    });

    var config = {
      method: "post",
      url: `${Appconfig.apiUrl}ledger/getUserBalance`,
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };

    axios(config)
      .then(function (response) {
        if (response.data.result == 0) {
        } else {
          setBalance(response.data.resultData?.balance);
          setExposure(response.data.resultData?.exposure);

          let getBal = response.data.resultData?.balance;
          let getExp = response.data.resultData?.exposure;
          let balWithoutExp = getBal - Math.abs(getExp);

          setbalanceWithExp(balWithoutExp);

          // setBalanceData(response.data.resultData)
          setLoadBalance(false);
        }
      })
      .catch(function (error) {
        console.log(error);
      });
  }

  useEffect(() => {
    if (userInfo) {
      dispatch(
        getAllBets({
          user_id: userInfo?._id,
        }),
      );
    }
  }, [userInfo?._id]);

  useEffect(() => {
    if (userInfo) {
      getBalance();
    }
  }, [userInfo, betData]);

  useEffect(() => {
    if (!userInfo) return;

    const chkLog = setInterval(() => {
      console.log("Checking for new login every 5 seconds");
      checkNewLogin();
    }, 5000);

    return () => clearInterval(chkLog);
  }, [userInfo]);

  const checkNewLogin = () => {
    var data = JSON.stringify({
      login_token: userInfo.login_token,
      user_id: userInfo._id,
    });

    var config = {
      method: "post",
      url: `${Appconfig.apiUrl}userToken/getToken`,
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };
    axios(config)
      .then(function (response) {
        try {
          if (response.data.result) {
          } else {
            localStorage.removeItem("userdata");
            localStorage.removeItem("login_token");
            localStorage.removeItem("loginTime");
            dispatch(emptyUserInfo());
            dispatch(emptyBalance());
            dispatch(emptyOpenBets());
            dispatch(emptyLoingUserData());
            setMyAccountListOpen(false);
            window.location.href = "/login";
          }
        } catch (e) {
          // postErrorToslack(e.message);
        }
      })
      .catch(function (error) {
        // postErrorToslack(error.message);
        console.log(error);
      });
  };

  return (
    <>
      <NotificationContainer />
      {/* Desktop */}
      <div className="hidden lg:block fixed z-[999] w-full">
        <div className="flex flex-row items-center justify-between w-full bg-[linear-gradient(-180deg,#474747_0%,#070707_100%)] h-[70px] p-[25px]">
          {/* Before login */}
          {!userInfo && (
            <>
              <div className="col-span-7 flex items-center justify-between">
                <div className="col-span-7 flex items-center justify-between">
                  <div>
                    <img
                      alt=""
                      className="w-[56px] h-[54px] ml-[20px]"
                      src={getLogoByDomain()}
                    />
                  </div>

                  {/* Search box outside showEventInp */}
                  <div
                    className="relative"
                    style={{
                      width: "280px",
                      height: "25px",
                      marginLeft: "20px",
                    }}
                  >
                    <div className="absolute inset-y-0 left-2 flex items-center pointer-events-none">
                      <IoSearch size={14} />
                    </div>

                    <input
                      type="text"
                      placeholder="Search events"
                      className="w-full h-full pl-7 pr-6 text-sm border border-gray-300 outline-none rounded-[4px]"
                      style={{ color: "#212529" }}
                    />

                    {/* <button
                      type="button"
                      className="absolute inset-y-0 right-2 flex items-center"
                    >
                      <IoMdClose size={14} />
                    </button> */}
                  </div>
                </div>

                {showEventInp && (
                  <div className="relative w-[17.5rem] username-inp">
                    <div className="absolute inset-y-0 start-0 flex items-center ps-3 pointer-events-none">
                      <IoSearch />
                    </div>
                    <input
                      type="text"
                      id="voice-search"
                      className="bg-gray-50 border border-gray-300 text-[1rem] block w-full ps-10 outline-none "
                      placeholder="Search Events"
                      required
                      style={{ borderRadius: ".25rem", color: "#212529" }}
                    />
                    <button
                      type="button"
                      className="absolute inset-y-0 end-0 flex items-center pe-3"
                    >
                      <IoMdClose />
                    </button>
                  </div>
                )}
              </div>
              <div className="grid col-span-5 px-[40px] items-center text-white text-2xl username-inp">
                <ul className="flex  items-center">
                  {/* <li
                    className="cursor-pointer mr-[20px]"
                    onClick={() => setShowEventInp(!showEventInp)}
                  >
                    <FaSearchPlus />
                  </li> */}
                  <li className="mr-[10px]">
                    <FaUser size={13} color="#ffcc2e " />
                  </li>

                  <li className="username-inp flex">
                    <input
                      value={formData.user_name}
                      onChange={handleInputChange}
                      type="text"
                      name="user_name"
                      id="user_name"
                      placeholder="Username"
                      maxLength={30}
                      className="text-[.875rem] font-normal w-[130px] h-[25px] bg-white outline-none"
                      style={{
                        borderRadius: ".25rem",
                        padding: ".375rem .75rem",
                        color: "#212529",
                      }}
                    />
                    <span className="absolute top-[50px] username-error hidden  text-[0.813rem] text-white leading-[14px]">
                      <div className="leading-[14px] ">
                        {user_nameValidationError}
                      </div>
                    </span>
                  </li>
                  <li className="password-inp ml-[5px] mr-[5px] flex">
                    <input
                      value={formData.password}
                      onChange={handleInputChange}
                      type="password"
                      minLength={6}
                      id="password"
                      name="password"
                      placeholder="Passwrod"
                      className="text-[.875rem] font-normal w-[130px] h-[25px] bg-white outline-none"
                      style={{
                        borderRadius: ".25rem",
                        padding: ".375rem .75rem",
                        color: "#212529",
                      }}
                    />
                    <span className="absolute top-[50px] password-error hidden  text-[0.813rem] text-white leading-[14px]">
                      <div className="leading-[14px]">
                        {passwordValidationError}
                      </div>
                    </span>
                  </li>

                  {/* CAPTCHA block */}
                  <li className="captcha-inp mr-[5px] flex relative">
                    {/* Placeholder-like text (only when input is empty) */}
                    {captchaInput.length === 0 && (
                      <span
                        className="absolute left-2 top-1/2 -translate-y-1/2 text-gray-500 pointer-events-none"
                        style={{ fontSize: "13px", fontWeight: "normal" }}
                      >
                        Validation
                      </span>
                    )}

                    {/* CAPTCHA digits on right corner */}
                    <span
                      className="absolute right-3 top-1/2 -translate-y-1/2 font-bold pointer-events-none select-none"
                      style={{ fontSize: "15px", color: "#000" }}
                    >
                      {captchaValue}
                    </span>

                    <input
                      type="text"
                      maxLength={4}
                      value={captchaInput}
                      onChange={(e) => setCaptchaInput(e.target.value)}
                      className="w-[130px] h-[25px] bg-white outline-none text-black font-normal"
                      style={{
                        borderRadius: ".25rem",
                        padding: ".375rem .75rem",
                        fontSize: "15px",
                        paddingRight: "45px", // prevent overlap with captcha digits on right
                      }}
                    />

                    {/* Error message */}
                    <span className="absolute top-[50px] captcha-error hidden text-[0.813rem] text-white leading-[14px]">
                      <div className="leading-[14px]">
                        {captchaValidationError}
                      </div>
                    </span>
                  </li>

                  <li className="w-[5rem]">
                    <button
                      className="flex items-center justify-center w-full gap-1 h-[1.563rem] bg-[linear-gradient(-180deg,_#bb1c00_0%,_#bb1c00_100%)] text-white text-[12px] font-bold"
                      style={{ borderRadius: "0.242rem" }}
                      onClick={handleSubmit}
                      disabled={isDisabled}
                    >
                      Login
                      <FaSignInAlt />
                    </button>
                  </li>

                  <li className="w-[5rem] ml-2">
                    <button
                      className="flex items-center justify-center w-full gap-1 h-[1.563rem] bg-[#666] bg-gradient-to-b from-[#666666] to-[#333333] text-white text-[12px] font-bold"
                      style={{ borderRadius: "0.242rem" }}
                      onClick={handleSubmit}
                      disabled={isDisabled}
                    >
                      Sign up
                    </button>
                  </li>
                </ul>
              </div>
            </>
          )}
          {/* after login */}
          {userInfo && (
            <>
              <div className="flex items-center text-[white]">
                {/* Logo */}
                <img
                  alt=""
                  className="block cursor-pointer w-[56px] h-[54px] relative top-[.5px] text-[white]"
                  src={getLogoByDomain()}
                />

                {/* Search Bar */}
                <div className="relative ml-6">
                  <div className="absolute inset-y-0 left-0 flex items-center pl-2 pointer-events-none">
                    {/* Search Icon SVG */}
                    <svg
                      aria-hidden="true"
                      className="w-4 h-4 text-black font-bold"
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="2.5"
                        d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
                      ></path>
                    </svg>
                  </div>
                  <input
                    type="search"
                    id="default-search"
                    className="block w-[320px] py-[2px] pl-8 text-[12px] text-gray-900 border border-gray-300 rounded-[3px] bg-white focus:outline-none placeholder-[#8da1b6]"
                    placeholder="Search Events"
                    required
                  />
                </div>
              </div>

              <div className="flex items-center text-[white]">
                {/* <ul className="relative [list-style:none]  flex items-center pl-8 text-[white]">
                  <li className="!mr-[20px] relative z-10 !float-left text-[white]">
                    <FaSearchPlus className="text-[white] text-[1.5rem] ml-[10px] float-right mt-[5px]" />
                  </li>
                </ul> */}
                <div className="flex items-center relative text-[white]">
                  <div className="flex-1 w-auto border border-black/30 rounded bg-white/10 text-[#ffb600] relative rounded-tr-[0] rounded-br-[0]">
                    {loadBalance ? (
                      /* Loading State */
                      <div className="loadingBalance w-full flex items-center justify-center h-full p-2">
                        <span className="dot-flashing"></span>
                      </div>
                    ) : (
                      /* Wallet Content */
                      <div className="h-full flex items-center shadow-[inset_0_1px_0_0_rgba(255,255,255,0.5)] rounded-l px-[7px] py-1 cursor-pointer">
                        <ul className="flex items-center w-full gap-3 text-[0.75rem] leading-[12px]">
                          {/* Main Balance Section */}
                          <li className="flex justify-center items-center">
                            <span className="opacity-70 font-normal text-xs mr-1">
                              Main Balance
                            </span>
                            <span className="font-bold">
                              PTI{" "}
                              {userInfo
                                ? balance && Number(balanceWithExp).toFixed(2)
                                : "0.00"}
                            </span>
                          </li>

                          {/* Exposure Section */}
                          <li
                            className="flex justify-center items-center cursor-pointer"
                            onClick={() => setExposureModal(true)}
                          >
                            <span className="opacity-70 font-normal text-xs mr-1">
                              Exposure
                            </span>
                            <span className="font-bold text-red-500">
                              {userInfo
                                ? exposure && Number(exposure).toFixed(2)
                                : "0.00"}
                            </span>
                          </li>

                          {/* Optional: The extra count badge from your HTML source (+3) 
            Remove this li if you don't have data for it */}
                          <li className="ml-auto font-bold text-[10px]">
                            +<span>0</span>
                          </li>
                        </ul>
                      </div>
                    )}

                    {/* Dropdown/Popover Logic would go here if you implement the 'open' state */}
                  </div>
                  <div>
                    <span className="ml-[0px] relative leading-[20px] flex mr-[7px] rounded-[2px] float-left h-[24px] bg-white/10 [box-shadow:inset_0_1px_0_0_rgba(255,_255,_255,_.4)] text-[#ffffff] w-[25px] px-[4px] py-[0] items-center justify-center rounded-tl-[0] rounded-bl-[0]">
                      <button
                        className="text-[#ffb600] leading-[20px]"
                        onClick={() => {
                          getBalance();
                          setLoadBalance(true);
                        }}
                      >
                        <svg
                          width="14"
                          height="14"
                          viewBox="0 0 16 16"
                          fill="#ffb600"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M8 0C5 0 2.4 1.6 1.1 4.1L0 3V7H4L2.5 5.5C3.5 3.5 5.6 2 8 2C11.3 2 14 4.7 14 8C14 11.3 11.3 14 8 14C6.2 14 4.6 13.2 3.5 11.9L2 13.2C3.4 14.9 5.6 16 8 16C12.4 16 16 12.4 16 8C16 3.6 12.4 0 8 0Z"
                            fill="#ffb600"
                          />
                        </svg>
                      </button>
                    </span>
                  </div>
                  <div className="relative bottom-[.5px] text-[white]">
                    <button
                      className="w-[110px] relative leading-[25px] bg-[0_-800px] float-left text-[.75rem] no-underline bg-white/10 mr-[20px] [box-shadow:inset_0_1px_0_0_rgba(255,_255,_255,_.4)] flex rounded-[2px] text-[white] pl-[7px] pr-[4px] py-[0] justify-between items-center"
                      onClick={() => setMyAccountListOpen(true)}
                    >
                      <FaUser className="text-[#fd8f3b]" />
                      My Account
                      <IoMdArrowDropdown className="text-[1rem] text-[#fd8f3b]" />
                    </button>
                    {myAccountListOpen && (
                      <ul
                        ref={ref}
                        className="absolute z-10 m-0 [transform:translate3d(0,_27px,_0)!important] [box-shadow:0_4px_5px_#00000080] pb-0 leading-normal block w-[222px] h-[256px] !right-[20px] float-left min-w-[10rem] p-0 text-[.875rem] text-[black] text-left [list-style:none] bg-[white] bg-clip-padding border-[1px] border-[#c8ced3] rounded-[.25rem]"
                      >
                        <li className="leading-normal text-[.875rem] text-[black] [list-style:none]">
                          <div className="block mb-0 text-[.765625rem] text-[black] bg-[#e4e7ea] whitespace-nowrap px-[10px] py-[4.5px] border-b-[1px] border-b-[#ccc] !text-left">
                            <strong className="text-[.765625rem] text-[black] !text-left leading-[1.5]">
                              {userInfo && userInfo?.user_name}
                            </strong>
                          </div>
                          <Link
                            to={"/myprofile"}
                            className="min-w-[220px] no-underline h-[26px] leading-[11px] px-[10px] py-[5px] border-b-[1px] border-b-[#c8ced3] block w-full clear-both font-normal text-[#212529] [text-align:inherit] whitespace-nowrap bg-transparent border-[0] hover:bg-[#e4e7ea]"
                            onClick={() => setMyAccountListOpen(false)}
                          >
                            My Profile
                          </Link>
                          <Link
                            to={"/rolling-commission"}
                            className="min-w-[220px] no-underline h-[26px] leading-[11px] px-[10px] py-[5px] border-b-[1px] border-b-[#c8ced3] block w-full clear-both font-normal text-[#212529] [text-align:inherit] whitespace-nowrap bg-transparent border-[0] hover:bg-[#e4e7ea]"
                            onClick={() => setMyAccountListOpen(false)}
                          >
                            Rolling Commission
                          </Link>
                          <Link
                            to={"/account-statement"}
                            className="min-w-[220px] no-underline h-[26px] leading-[11px] px-[10px] py-[5px] border-b-[1px] border-b-[#c8ced3] block w-full clear-both font-normal text-[#212529] [text-align:inherit] whitespace-nowrap bg-transparent border-[0] hover:bg-[#e4e7ea]"
                            onClick={() => setMyAccountListOpen(false)}
                          >
                            Account Statement
                          </Link>
                          <Link
                            to={"/bet-history"}
                            className="min-w-[220px] no-underline h-[26px] leading-[11px] px-[10px] py-[5px] border-b-[1px] border-b-[#c8ced3] block w-full clear-both font-normal text-[#212529] [text-align:inherit] whitespace-nowrap bg-transparent border-[0] hover:bg-[#e4e7ea]"
                            onClick={() => setMyAccountListOpen(false)}
                          >
                            Bets History
                          </Link>
                          <Link
                            to={"/profit-loss"}
                            className="min-w-[220px] no-underline h-[26px] leading-[11px] px-[10px] py-[5px] border-b-[1px] border-b-[#c8ced3] block w-full clear-both font-normal text-[#212529] [text-align:inherit] whitespace-nowrap bg-transparent border-[0] hover:bg-[#e4e7ea]"
                            onClick={() => setMyAccountListOpen(false)}
                          >
                            Profit & Loss
                          </Link>
                          <Link
                            to={"/password-history"}
                            className="min-w-[220px] no-underline h-[26px] leading-[11px] px-[10px] py-[5px] border-b-[1px] border-b-[#c8ced3] block w-full clear-both font-normal text-[#212529] [text-align:inherit] whitespace-nowrap bg-transparent border-[0] hover:bg-[#e4e7ea]"
                            onClick={() => setMyAccountListOpen(false)}
                          >
                            Password History
                          </Link>
                          <Link
                            to={"/activity-log"}
                            className="min-w-[220px] no-underline h-[26px] leading-[11px] px-[10px] py-[5px] border-b-[1px] border-b-[#c8ced3] block w-full clear-both font-normal text-[#212529] [text-align:inherit] whitespace-nowrap bg-transparent border-[0] hover:bg-[#e4e7ea]"
                            onClick={() => setMyAccountListOpen(false)}
                          >
                            Activity Log
                          </Link>
                          <div className="min-w-[220px] no-underline h-[39px] px-[10px] py-[9px] border-b-[none] leading-[11px] w-[220px] block clear-both font-normal text-[#212529] [text-align:inherit] whitespace-nowrap bg-transparent border-[0]">
                            <button
                              className="w-full pt-[7px] px-[10px] pb-[5px] font-bold h-[27px] leading-[10px] text-[0.813rem] mr-[4px] rounded-[3.6px] text-[white] bg-[linear-gradient(-180deg,#474747_0%,#070707_100%)] flex justify-center items-center"
                              onClick={() => logout()}
                            >
                              LOGOUT
                              <svg
                                className="w-[20px]"
                                width="14"
                                height="12"
                                viewBox="0 0 14 12"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  d="M13.8062 6.96533L9.13934 11.777C8.72265 12.2066 8.0004 11.9059 8.0004 11.2901V8.54059H4.22243C3.85297 8.54059 3.55573 8.23413 3.55573 7.8532V5.10366C3.55573 4.72273 3.85297 4.41627 4.22243 4.41627H8.0004V1.66673C8.0004 1.05381 8.71988 0.750214 9.13934 1.17983L13.8062 5.99153C14.0646 6.26076 14.0646 6.6961 13.8062 6.96533ZM5.3336 11.6338V10.4882C5.3336 10.2991 5.18359 10.1445 5.00025 10.1445H2.6668C2.17511 10.1445 1.77787 9.73492 1.77787 9.22797V3.72889C1.77787 3.22194 2.17511 2.81237 2.6668 2.81237H5.00025C5.18359 2.81237 5.3336 2.65771 5.3336 2.46868V1.32304C5.3336 1.134 5.18359 0.979342 5.00025 0.979342H2.6668C1.1945 0.979342 0 2.21091 0 3.72889V9.22797C0 10.7459 1.1945 11.9775 2.6668 11.9775H5.00025C5.18359 11.9775 5.3336 11.8229 5.3336 11.6338Z"
                                  fill="white"
                                />
                              </svg>
                            </button>
                          </div>
                        </li>
                      </ul>
                    )}
                  </div>
                </div>
              </div>
            </>
          )}
        </div>
        <div className="flex justify-between items-center bg-[linear-gradient(180deg,_#ffcc2e_0%,_#ffbd14_100%)] h-[30px]">
          {/* LEFT SIDE NAV ITEMS */}
          <ul className="flex ml-[25px] mr-[0] my-[0] font-bold">
            {navItems.map((item, index) => {
              const isActive = location.pathname === item.url;

              // DYNAMIC LIVE COUNT
              let liveCount = 0;
              if (item.title === "Cricket") liveCount = cricket;
              if (item.title === "Tennis") liveCount = tennis;
              if (item.title === "Soccer") liveCount = soccer;
              if (item.title === "E-Soccer") liveCount = esoccer;

              // Always show badge for these 3 sports — even if liveCount = 0
              const showLiveTag =
                item.title === "Cricket" ||
                item.title === "Tennis" ||
                item.title === "Soccer" ||
                item.title === "E-Soccer";

              return (
                <li
                  key={index}
                  className="relative flex py-[0] leading-[30px]"
                  style={{ borderRight: "1px solid #797777" }}
                >
                  <span
                    className="cursor-pointer font-bold text-[0.813rem] w-max relative"
                    style={
                      isActive
                        ? {
                            background: "#ffdc7a",
                            boxShadow: "inset 0 0px 5px rgba(83, 33, 33, 0.5)",
                            padding: "0 10px",
                          }
                        : {
                            padding: "0 10px",
                          }
                    }
                    onClick={() =>
                      item.url === "/multimarket" ||
                      item.url === "/virtual-sports"
                        ? setAgeModalOpen(true)
                        : navigate(item.url)
                    }
                  >
                    {/* ALWAYS SHOW BADGE FOR CRICKET/TENNIS/SOCCER */}
                    {showLiveTag && (
                      <span
                        className="absolute -top-[6px] right-[3px] flex items-center justify-center"
                        style={{
                          minWidth: "33px",
                          height: "12px",
                          borderRadius: "3px",
                          paddingRight: "3px",
                          color: "#fff",
                          fontSize: "10px",
                          backgroundImage:
                            "linear-gradient(180deg, #fb3434 0%, #e80505 100%)",
                          boxShadow: "0 1px 3px rgba(0,0,0,.5)",
                        }}
                      >
                        <strong
                          className="flex items-center justify-center"
                          style={{
                            flex: 1,
                            height: "100%",
                            marginRight: "3px",
                            padding: "0 2px",
                            borderRadius: "3px 0 0 3px",
                            backgroundImage:
                              "linear-gradient(180deg, #ffffff 0%, #eeeeee 89%)",
                          }}
                        >
                          <svg
                            width="14"
                            height="8"
                            xmlns="http://www.w3.org/2000/svg"
                            style={{
                              animation: "twinkling 1.4s infinite ease",
                            }}
                          >
                            <g fill="rgb(255,0,0)" fillRule="evenodd">
                              <path d="M12.012 0l-.698.727c1.734 1.808 1.734 4.738 0 6.546l.698.727c2.117-2.207 2.117-5.79 0-8zM10.3 1.714l-.7.735c.967 1.014.967 2.66 0 3.673l.7.735c1.352-1.418 1.352-3.721 0-5.143zM1.588 0l.698.727c-1.734 1.808-1.734 4.738 0 6.546L1.588 8c-2.117-2.207-2.117-5.79 0-8zM3.3 1.714l.7.735c-.967 1.014-.967 2.66 0 3.673l-.7.735c-1.352-1.418-1.352-3.721 0-5.143z" />
                              <circle cx="6.8" cy="4.4" r="1.6" />
                            </g>
                          </svg>
                        </strong>

                        {/* SHOW 0 WHEN EMPTY */}
                        {liveCount}
                      </span>
                    )}

                    {item.title}
                  </span>
                </li>
              );
            })}
          </ul>

          {/* RIGHT SIDE TIME ZONE */}
          <ul className="flex items-center ml-[25px] mr-[0] my-[0]">
            <li className="px-[10px] text-[0.813rem] font-semibold">
              Time Zone : <strong>GMT+5:30</strong>
            </li>
            <li>
              <a
                id="oneClickSetting"
                className="one_click cursor-pointer flex items-center gap-1 text-[#ffc828] px-3 py-1 mb-[6px] border-t-4 border-[#ffb600] bg-gradient-to-b from-[#4b4b4b] to-[#1e1e1e] relative after:content-[''] after:absolute after:w-[16px] after:h-[16px] after:bg-[rgba(255,255,255,.15)] after:rounded-[4px] after:top-1/2 after:left-[10px] after:-translate-y-1/2 after:z-[1]"
                onClick={() => console.log("One Click Bet clicked")}
              >
                <img
                  src="/images/transparent.gif"
                  alt="One Click Bet Icon"
                  className="w-[16px] h-[16px] relative z-[2]" // Ensures image layer above ::after
                />
                <span className="ml-[4px] relative z-[2]">One Click Bet</span>
              </a>
            </li>
            <li>
              <a
                id="slipSet"
                className="setting px-[10px]"
                style={{
                  cursor: "pointer",
                  display: "flex",
                  alignItems: "center",
                }}
                onClick={() => console.log("Setting clicked")}
              >
                Setting
                <img src="/images/transparent.gif" alt="" />
              </a>
            </li>
          </ul>
        </div>
      </div>

      {/* Mobile */}
      <div className="flex w-full lg:hidden fixed z-[999]">
        <div className="grid grid-cols-12 w-full h-[56px] bg-[linear-gradient(-180deg,#474747_0%,#070707_100%)]">
          {/* Before Login */}
          {!userInfo && (
            <div className="col-span-12 flex items-center">
              <div className="flex items-center justify-between w-full">
                <div className="flex items-center ml-[3px]">
                  <img
                    alt=""
                    className="relative left-[4px] w-[3rem] h-[2.7rem]"
                    src={getLogoByDomain()} // Using the common function
                  />
                </div>
                <div className="flex items-center text-center text-white">
                  <div className="flex items-center">
                    {/* --- UPDATED SIGN UP BUTTON --- */}
                    <button
                      className="signup-button btn-signup flex items-center justify-center bg-[linear-gradient(-180deg,_#666666_0%,_#333333_100%)] border-[#000] border text-[13px] leading-normal rounded-[.2rem] h-[33px] w-[100px] mr-[3px] font-bold"
                      // onClick={() => navigate("/signup")}
                    >
                      Sign up
                    </button>

                    <button
                      className="flex h-[28px] items-center justify-center bg-[linear-gradient(-180deg,_#e93522_0%,_#be2414_100%)] text-[.765625rem] leading-normal rounded-[.2rem] h-[33px] w-[100px] mr-[8px] ml-[0px] mb-[2px]"
                      onClick={() => navigate("/login")}
                    >
                      <img
                        src="data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' width='17' height='17' viewBox='0 0 17 17'><path fill='rgb(255,255,255)' fill-rule='evenodd' d='M11.797 11.65c2.342.338 4.072 1.702 4.51 2.1C16.74 14.148 17 17 17 17H0s-.03-2.314.744-3.25c.437-.398 1.81-1.762 4.153-2.1 2.326-.322 1.616-2.774 1.696-2.743.08.045-.016-.522-.016-.522S4.88 6.837 4.897 5.442c.032-1.41 0-2.132 0-2.132S5.17 0 7.563 0l1.34.614c2.15 0 2.505 2.696 2.505 2.696v2.33S11.134 7.62 9.792 8.34c0 0-.096.57-.015.52.08-.03-.307 2.47 2.02 2.792z'/></svg>"
                        className="ml-[.25rem] p-[.5px]"
                      />

                      <b> Login</b>
                      {/* <FaUser className='ml-[.25rem] p-[.5px]' /> */}
                    </button>
                    {/* <Modal
                      className="age-model"
                      open={ageModalOpen}
                      footer={null}
                      onOk={handleAgeOk}
                      centered
                      onCancel={handleCancel}
                    >
                      <div className="grid grid-cols-12">
                        <div className="col-span-12 mt-[20px]">
                          <div className="text-[1rem]">
                            Non-Gambling Territories.
                          </div>
                          <hr className="mx-[0] my-4" />
                          <div className="text-[0.875rem] mb-[35px]">
                            Connecting to our site from non gambling countries,
                            it will be User's responsibility to ensure that
                            their use of the service is lawful.
                          </div>
                        </div>

                        <div className="col-span-12">
                          <div className="text-[1rem]">
                            Underage gambling is prohibited.
                          </div>
                          <hr className="mx-[0] my-4" />
                          <div className="text-[0.875rem] mb-[35px]">
                            Please confirm if you are 18 years old and above as
                            of today.
                          </div>
                        </div>

                        <div className="col-span-12 flex justify-center ">
                          <button
                            className="bg-[#ffffff] text-[#000000] px-[5px] text-[0.813rem] h-[30px] w-[90px] outline-[0] rounded-[4px] font-bold flex-[.3] mr-[10px] border-[1px] border-[solid] border-[#ffffff]"
                            onClick={() => {
                              setAgeModalOpen(false);
                              navigate("/login");
                            }}
                          >
                            <span>Confirm</span>
                          </button>

                          <button
                            className="text-[0.813rem] h-[30px] px-[5px] w-[90px] outline-[0] rounded-[4px] font-bold flex-[.3] mr-[10px] bg-[#000000] text-[#ffffff] border-[1px] border-[solid] border-[#ffffff]"
                            onClick={() => setAgeModalOpen(false)}
                          >
                            <span>Exit</span>
                          </button>
                        </div>
                      </div>
                    </Modal> */}
                  </div>
                </div>
              </div>
            </div>
          )}

          {/* After Login */}
          {userInfo && (
            <div className="col-span-12">
              <Modal
                className="recent-result-modal relative top-1 lg:top-7 w-[500px]"
                open={exposureModal}
                onOk={handleExposureOk}
                footer={null}
                onCancel={handleExposureCancel}
              >
                <div className="grid grid-cols-12">
                  <div className="col-span-12 flex rounded-t-[5px] items-center h-[35px] justify-between py-[6px] px-[15px] bg-[linear-gradient(-180deg,_#184438_0%,_#000000_100%)] text-[#ffffff]">
                    <span className="leading-normal text-[.938rem]">
                      {" "}
                      Exposure Detail{" "}
                    </span>
                    <button
                      type="button"
                      className="text-[1.3rem] font-bold"
                      onClick={() => setExposureModal(false)}
                    >
                      ×
                    </button>
                  </div>
                  <div className="col-span-12 p-[5px]">
                    <table className="border-collapse border border-slate-500 ">
                      <thead className="align-bottom text-[.75rem]">
                        <th className="w-[20%] p-[7px] border border-slate-600 bg-[#dee2e6] font-bold text-[15px]">
                          Sport Name
                        </th>
                        <th className="w-[40%] p-[7px] border border-slate-600 bg-[#dee2e6] font-bold text-[15px]">
                          Event Name
                        </th>
                        <th className="w-[20%] p-[7px] border border-slate-600 bg-[#dee2e6] font-bold text-[15px]">
                          Market Name
                        </th>
                        <th className="w-[20%] p-[7px] border border-slate-600 bg-[#dee2e6] font-bold text-[15px]">
                          Trade
                        </th>
                      </thead>
                      <tbody>
                        {openBetShow.length
                          ? openBetShow.map((bets) => {
                              return (
                                <tr>
                                  <td className="p-[7px] border border-slate-600 font-bold text-[14px]">
                                    {bets.event_type == 4
                                      ? "Cricket"
                                      : bets.event_type == 2
                                        ? "Tennis"
                                        : bets.event_type == 1
                                          ? "Soccer"
                                          : "Casino"}
                                  </td>
                                  <td className="p-[7px] border border-slate-600 font-bold text-[14px]">
                                    <Link
                                      to={`${
                                        [1, 2, 4].includes(bets?.event_type)
                                          ? `/fullMarket/${bets?.match_id}/Going Inplay`
                                          : `/casino/${bets?.event_type}`
                                      }`}
                                      onClick={() => setExposureModal(false)}
                                      className="text-[#2789ce]"
                                    >
                                      {bets.event_name}
                                    </Link>
                                  </td>
                                  <td className="p-[7px] border border-slate-600 font-bold text-[14px]">
                                    {bets.market_name}
                                  </td>
                                  <td className="p-[7px] border border-slate-600 font-bold text-[14px]">
                                    {bets.totalByMatch}
                                  </td>
                                </tr>
                              );
                            })
                          : ""}
                      </tbody>
                    </table>
                  </div>
                </div>
              </Modal>
              {headerChange ? (
                <>
                  <div className="flex justify-between h-[58px] text-center text-[white]">
                    <div className="flex items-center text-center text-[white]">
                      <button
                        type="button"
                        className="relative bottom-[1.5px] text-[14px] !text-[white] [box-shadow:inset_0_1px_0_0_rgba(255,_255,_255,_.4)] bg-[linear-gradient(-180deg,#14805e_0,_#184438_100%)] h-[9.33333vw] leading-[5.33333vw] font-bold rounded-[1.06667vw] border-[1px] border-[solid] border-[#0b1933] px-[2.86667vw] py-[2.6vw] ml-px justify-center items-center flex"
                        onClick={() => {
                          setOpenRules(true);
                        }}
                      >
                        Rules
                      </button>
                      <Modal
                        title={"Open Rules"}
                        className="openbets-modal "
                        onCancel={() => setOpenRules(false)}
                        open={openRules}
                        mask={null}
                        footer={null}
                      >
                        <OpenRules />
                      </Modal>
                    </div>
                    <div className="flex items-center text-center text-[white] ">
                      <Link
                        to={"/live-casino"}
                        className="relative bottom-[1.5px] text-[12px] !text-[white] [box-shadow:inset_0_1px_0_0_rgba(255,_255,_255,_.4)] bg-[linear-gradient(-180deg,#14805e_0,_#184438_100%)] h-[9.33333vw] leading-[3.33333vw] font-bold rounded-[1.06667vw] border-[1px] border-[solid] border-[#0b1933] px-[2.86667vw] py-[2.6vw] ml-px justify-center items-center flex"
                      >
                        GAMING <br /> LOBBY
                      </Link>
                    </div>
                    <div className="flex items-center text-center text-[white]">
                      {loadBalance && (
                        <div className="loadingBalance w-full ">
                          <span></span>
                          <span></span>
                          <span></span>
                          <span></span>
                          <span></span>
                          <span></span>
                          <span></span>
                        </div>
                      )}
                      {!loadBalance && (
                        <div className="flex items-center relative text-center text-[white]">
                          <div className="block mr-[10px] text-[.75rem] font-bold text-left text-[white]">
                            <div className="text-center text-[.75rem] font-bold text-[white]">
                              <span className="block relative bottom-[3px] left-[8px] text-[.75rem] font-bold text-[white]">
                                {`Main `}
                                <strong>
                                  PTI
                                  <span>{` ${
                                    balance && Number(balanceWithExp).toFixed(2)
                                  } `}</span>
                                </strong>
                              </span>
                              <span className="ml-[20px] relative top-px right-[2px] block text-[.75rem] font-bold text-[white]">
                                {` Exposure `}
                                <a className="text-[white] cursor-pointer text-[.75rem] font-bold">
                                  <strong className="text-[white] text-[.75rem] font-[bolder]">
                                    (
                                    <strong
                                      onClick={() => setExposureModal(true)}
                                    >
                                      <span className="text-[red] text-[0.813rem]">
                                        {userInfo
                                          ? balance &&
                                            Math.abs(Number(exposure)).toFixed(
                                              2,
                                            )
                                          : ""}
                                      </span>
                                    </strong>
                                    )
                                  </strong>
                                </a>
                              </span>
                            </div>
                          </div>
                        </div>
                      )}

                      <div className="flex text-center text-[white] ml-[10px]">
                        <div className="relative bottom-px right-[2px] text-[white] [box-shadow:inset_0_1px_0_0_rgba(255,_255,_255,_.4)] bg-[linear-gradient(-180deg,#14805e_0,_#184438_100%)] h-[9.33333vw] leading-[5.33333vw] font-bold rounded-[5px] border-[1px] border-[solid] border-[#0b1933] px-[1.86667vw] py-[2.6vw] justify-center items-center flex mr-[6px]">
                          <button
                            type="button"
                            className="text-[white] leading-[5.33333vw] font-bold text-center"
                            onClick={() => {
                              getBalance();
                              setLoadBalance(true);
                            }}
                          >
                            <svg
                              width="20"
                              height="20"
                              xmlns="http://www.w3.org/2000/svg"
                              xmlnsXlink="http://www.w3.org/1999/xlink"
                            >
                              <path
                                d="M10 4.029c1.635 0 3.144.36 4.527 1.079 1.365.703 2.443 1.655 3.233 2.854.827 1.247 1.24 2.59 1.24 4.028 0 1.44-.413 2.782-1.24 4.03-.79 1.214-1.868 2.173-3.233 2.877A9.596 9.596 0 0 1 10 20a9.596 9.596 0 0 1-4.527-1.103c-1.365-.704-2.443-1.663-3.233-2.878C1.413 14.772 1 13.43 1 11.99h2.263c0 1.088.301 2.09.903 3.01.602.92 1.42 1.647 2.452 2.182 1.033.536 2.16.804 3.382.804s2.349-.268 3.382-.804c1.033-.535 1.85-1.263 2.452-2.182.602-.92.903-1.922.903-3.01 0-1.087-.301-2.09-.903-3.01-.602-.918-1.42-1.646-2.452-2.181-1.033-.536-2.16-.804-3.382-.804v4.029L4.368 5.012 10 0v4.029z"
                                fill="currentColor"
                              ></path>
                            </svg>
                          </button>
                        </div>

                        <div className="flex items-center text-center text-[white]">
                          <button
                            type="button"
                            className="relative bottom-[1.5px] text-[14px] !text-[white] [box-shadow:inset_0_1px_0_0_rgba(255,_255,_255,_.4)] bg-[linear-gradient(-180deg,#14805e_0,_#184438_100%)] h-[9.33333vw] leading-[5.33333vw] font-bold rounded-[1.06667vw] border-[1px] border-[solid] border-[#0b1933] px-[2.86667vw] py-[2.6vw] ml-px justify-center items-center flex"
                            onClick={() => {
                              setOpenbets(true);
                            }}
                          >
                            <svg
                              className="w-[20px] h-[20px]"
                              xmlns="http://www.w3.org/2000/svg"
                              width="20"
                              height="20"
                              viewBox="0 0 20 20"
                            >
                              <path
                                fill="currentColor"
                                fillRule="nonzero"
                                d="M19.314 6.38c-.41-1.052-.987-2.018-1.708-2.862-1.49-1.75-3.574-2.97-5.94-3.368C11.125.06 10.57 0 10 0c-.57 0-1.124.06-1.667.15-2.365.398-4.447 1.62-5.94 3.367-.72.845-1.297 1.81-1.707 2.863C.25 7.504 0 8.722 0 10c0 1.175.213 2.297.585 3.344.38 1.066.927 2.05 1.62 2.914 1.503 1.868 3.662 3.178 6.128 3.592.543.09 1.098.15 1.667.15.57 0 1.124-.06 1.667-.15 2.466-.414 4.625-1.724 6.127-3.592.694-.864 1.242-1.848 1.62-2.913.373-1.047.586-2.17.586-3.345 0-1.278-.25-2.496-.686-3.62zm-1.173.678l-1.747 1.01c-.332-1.095-.937-2.07-1.735-2.848l1.764-1.02c.746.826 1.333 1.793 1.72 2.858zM15.348 10c0 2.948-2.398 5.347-5.347 5.347-2.95 0-5.347-2.4-5.347-5.347 0-2.948 2.398-5.347 5.347-5.347 2.95 0 5.347 2.4 5.347 5.347zM10 1.333c.57 0 1.127.06 1.667.165v2.04c-.534-.137-1.09-.218-1.667-.218-.576 0-1.133.08-1.667.22V1.497c.54-.106 1.097-.165 1.667-.165zM3.578 4.2l1.765 1.02c-.8.778-1.404 1.753-1.736 2.847L1.86 7.057c.385-1.065.973-2.03 1.718-2.856zm-1.82 8.467l1.775-1.024c.282 1.112.84 2.11 1.604 2.923L3.38 15.58c-.717-.848-1.272-1.834-1.622-2.913zm8.242 6c-.57 0-1.127-.06-1.667-.165v-2.04c.534.137 1.09.218 1.667.218.576 0 1.133-.08 1.667-.22v2.042c-.54.106-1.097.165-1.667.165zm6.62-3.087l-1.757-1.014c.763-.81 1.322-1.81 1.604-2.923l1.775 1.025c-.35 1.078-.905 2.064-1.622 2.912zm-6.003-6.325c1.174.418 1.647.966 1.647 1.862 0 .887-.62 1.644-1.755 1.843v.514c0 .27-.218.488-.485.488s-.483-.218-.483-.488v-.444c-.39-.018-.772-.088-1.098-.187-.332-.1-.526-.448-.44-.787l.005-.017c.035-.145.13-.265.258-.335.13-.07.28-.08.42-.03.328.117.708.2 1.11.2.563 0 .947-.22.947-.618 0-.38-.315-.618-1.045-.867-1.056-.358-1.775-.856-1.775-1.822 0-.877.61-1.564 1.667-1.773v-.458c0-.285.24-.513.53-.486.25.025.436.247.436.5v.375c.347.016.634.062.875.125.315.082.504.406.423.723l-.01.034c-.034.14-.124.258-.248.328s-.27.086-.407.043c-.238-.075-.538-.137-.908-.137-.642 0-.848.28-.848.56 0 .327.344.536 1.183.855z"
                              ></path>
                            </svg>
                          </button>
                          {/* <OpenBets open={openbets} /> */}
                          <Modal
                            title={"Open Bets"}
                            className="openbets-modal "
                            onCancel={() => setOpenbets(false)}
                            open={openbets}
                            mask={null}
                            footer={null}
                          >
                            <OpenBets />
                          </Modal>
                        </div>
                      </div>
                    </div>
                  </div>
                </>
              ) : (
                <>
                  <div className="flex justify-between h-[58px] text-center text-[white]">
                    <div className="flex items-center text-center text-[white]">
                      <button
                        type="button"
                        className=" min-w-[29.3333333333vw] max-w-[31.2vw] relative bottom-[1.5px] text-[14px] !text-[white] [box-shadow:inset_0_1px_0_0_rgba(255,_255,_255,_.4)] bg-[rgba(255,_255,_255,_.1)] h-[9.33333vw] leading-[5.33333vw] font-bold rounded-[1.06667vw] border-[1px] border-[solid] border-[#0b1933] px-[2.86667vw] py-[2.6vw] -ml-[3px] justify-center items-center flex"
                        onClick={() => {
                          setOpenbets(true);
                        }}
                      >
                        <svg
                          className="w-[20px] h-[20px] mr-[5px]"
                          xmlns="http://www.w3.org/2000/svg"
                          width="20"
                          height="20"
                          viewBox="0 0 20 20"
                        >
                          <path
                            fill="#ffb200"
                            fillRule="nonzero"
                            d="M19.314 6.38c-.41-1.052-.987-2.018-1.708-2.862-1.49-1.75-3.574-2.97-5.94-3.368C11.125.06 10.57 0 10 0c-.57 0-1.124.06-1.667.15-2.365.398-4.447 1.62-5.94 3.367-.72.845-1.297 1.81-1.707 2.863C.25 7.504 0 8.722 0 10c0 1.175.213 2.297.585 3.344.38 1.066.927 2.05 1.62 2.914 1.503 1.868 3.662 3.178 6.128 3.592.543.09 1.098.15 1.667.15.57 0 1.124-.06 1.667-.15 2.466-.414 4.625-1.724 6.127-3.592.694-.864 1.242-1.848 1.62-2.913.373-1.047.586-2.17.586-3.345 0-1.278-.25-2.496-.686-3.62zm-1.173.678l-1.747 1.01c-.332-1.095-.937-2.07-1.735-2.848l1.764-1.02c.746.826 1.333 1.793 1.72 2.858zM15.348 10c0 2.948-2.398 5.347-5.347 5.347-2.95 0-5.347-2.4-5.347-5.347 0-2.948 2.398-5.347 5.347-5.347 2.95 0 5.347 2.4 5.347 5.347zM10 1.333c.57 0 1.127.06 1.667.165v2.04c-.534-.137-1.09-.218-1.667-.218-.576 0-1.133.08-1.667.22V1.497c.54-.106 1.097-.165 1.667-.165zM3.578 4.2l1.765 1.02c-.8.778-1.404 1.753-1.736 2.847L1.86 7.057c.385-1.065.973-2.03 1.718-2.856zm-1.82 8.467l1.775-1.024c.282 1.112.84 2.11 1.604 2.923L3.38 15.58c-.717-.848-1.272-1.834-1.622-2.913zm8.242 6c-.57 0-1.127-.06-1.667-.165v-2.04c.534.137 1.09.218 1.667.218.576 0 1.133-.08 1.667-.22v2.042c-.54.106-1.097.165-1.667.165zm6.62-3.087l-1.757-1.014c.763-.81 1.322-1.81 1.604-2.923l1.775 1.025c-.35 1.078-.905 2.064-1.622 2.912zm-6.003-6.325c1.174.418 1.647.966 1.647 1.862 0 .887-.62 1.644-1.755 1.843v.514c0 .27-.218.488-.485.488s-.483-.218-.483-.488v-.444c-.39-.018-.772-.088-1.098-.187-.332-.1-.526-.448-.44-.787l.005-.017c.035-.145.13-.265.258-.335.13-.07.28-.08.42-.03.328.117.708.2 1.11.2.563 0 .947-.22.947-.618 0-.38-.315-.618-1.045-.867-1.056-.358-1.775-.856-1.775-1.822 0-.877.61-1.564 1.667-1.773v-.458c0-.285.24-.513.53-.486.25.025.436.247.436.5v.375c.347.016.634.062.875.125.315.082.504.406.423.723l-.01.034c-.034.14-.124.258-.248.328s-.27.086-.407.043c-.238-.075-.538-.137-.908-.137-.642 0-.848.28-.848.56 0 .327.344.536 1.183.855z"
                          ></path>
                        </svg>
                        <span className="text-[#ffb200]">Bets</span>
                      </button>
                      {/* <OpenBets open={openbets} /> */}
                      <Modal
                        title={"Open Bets"}
                        className="openbets-modal "
                        onCancel={() => setOpenbets(false)}
                        open={openbets}
                        mask={null}
                        footer={null}
                      >
                        <OpenBets />
                      </Modal>
                    </div>
                    <div className="flex items-center text-center text-[white]">
                      {loadBalance && (
                        <div className="loadingBalance w-full ">
                          <span></span>
                          <span></span>
                          <span></span>
                          <span></span>
                          <span></span>
                          <span></span>
                          <span></span>
                        </div>
                      )}
                      {!loadBalance && (
                        <div className="w-full flex justify-between items-center px-[6px]">
                          {/* Left Corner: Balance & Exposure */}
                          <div className="relative text-[white] rounded-tr-none rounded-br-none [box-shadow:inset_0_1px_0_0_rgba(255,_255,_255,_.4)] bg-[rgba(255,_255,_255,_.1)] h-[9.33333vw] leading-[5.33333vw] font-bold rounded-[5px] border-[1px] border-[solid] border-[#0b1933] px-[1.86667vw] py-[2.6vw] justify-center items-center flex">
                            <div className="block mr-[10px] text-[.75rem] font-bold text-left text-[white]">
                              <div className="text-center text-[.75rem] font-bold text-[white] leading-[15px] leading-[10px]">
                                <span className="block bottom-[3px] left-[8px] text-[.75rem] font-normal text-[#ffb200]">
                                  {`Main `}
                                  <strong>
                                    PTI
                                    <span>{` ${
                                      balance &&
                                      Number(balanceWithExp).toFixed(2)
                                    } `}</span>
                                  </strong>
                                </span>
                                <span className="ml-[8px] top-px right-[2px] block text-[.75rem] font-normal text-[#ffb200]">
                                  {` Exposure `}
                                  <a className="text-[white] cursor-pointer text-[.75rem] font-bold">
                                    <strong className="text-[white] text-[.75rem] font-[bolder]">
                                      (
                                      <strong
                                        onClick={() => setExposureModal(true)}
                                      >
                                        <span className="text-[red] text-[0.813rem]">
                                          {userInfo
                                            ? balance &&
                                              Math.abs(
                                                Number(exposure),
                                              ).toFixed(2)
                                            : ""}
                                        </span>
                                      </strong>
                                      )
                                    </strong>
                                  </a>
                                </span>
                              </div>
                            </div>
                          </div>

                          {/* Right Corner: Refresh Button */}
                          <div className="relative text-[white] rounded-tl-none rounded-bl-none [box-shadow:inset_0_1px_0_0_rgba(255,_255,_255,_.4)] bg-[rgba(255,_255,_255,_.1)] h-[9.33333vw] leading-[5.33333vw] font-bold rounded-[5px] border-[1px] border-[solid] border-[#0b1933] px-[1.86667vw] py-[2.6vw] justify-center items-center flex">
                            <button
                              type="button"
                              className="text-[white] leading-[5.33333vw] font-bold text-center"
                              onClick={() => {
                                getBalance();
                                setLoadBalance(true);
                              }}
                            >
                              <svg
                                width="20"
                                height="20"
                                xmlns="http://www.w3.org/2000/svg"
                                xmlnsXlink="http://www.w3.org/1999/xlink"
                              >
                                <path
                                  d="M10 4.029c1.635 0 3.144.36 4.527 1.079 1.365.703 2.443 1.655 3.233 2.854.827 1.247 1.24 2.59 1.24 4.028 0 1.44-.413 2.782-1.24 4.03-.79 1.214-1.868 2.173-3.233 2.877A9.596 9.596 0 0 1 10 20a9.596 9.596 0 0 1-4.527-1.103c-1.365-.704-2.443-1.663-3.233-2.878C1.413 14.772 1 13.43 1 11.99h2.263c0 1.088.301 2.09.903 3.01.602.92 1.42 1.647 2.452 2.182 1.033.536 2.16.804 3.382.804s2.349-.268 3.382-.804c1.033-.535 1.85-1.263 2.452-2.182.602-.92.903-1.922.903-3.01 0-1.087-.301-2.09-.903-3.01-.602-.918-1.42-1.646-2.452-2.181-1.033-.536-2.16-.804-3.382-.804v4.029L4.368 5.012 10 0v4.029z"
                                  fill="#ffb200"
                                ></path>
                              </svg>
                            </button>
                          </div>
                        </div>
                      )}

                      <div className="flex text-center text-[white] ml-[10px]">
                        {/* <div className="relative rounded-tl-none rounded-bl-none bottom-px right-[2px] text-[white] [box-shadow:inset_0_1px_0_0_rgba(255,_255,_255,_.4)] bg-[rgba(255,_255,_255,_.1)] h-[9.33333vw] leading-[5.33333vw] font-bold rounded-[5px] border-[1px] border-[solid] border-[#0b1933] px-[1.86667vw] py-[2.6vw] justify-center items-center flex mr-[6px]">
                          <button
                            type="button"
                            className="text-[white] leading-[5.33333vw] font-bold text-center"
                            onClick={() => {
                              getBalance();
                              setLoadBalance(true);
                            }}
                          >
                            <svg
                              width="20"
                              height="20"
                              xmlns="http://www.w3.org/2000/svg"
                              xmlnsXlink="http://www.w3.org/1999/xlink"
                            >
                              <path
                                d="M10 4.029c1.635 0 3.144.36 4.527 1.079 1.365.703 2.443 1.655 3.233 2.854.827 1.247 1.24 2.59 1.24 4.028 0 1.44-.413 2.782-1.24 4.03-.79 1.214-1.868 2.173-3.233 2.877A9.596 9.596 0 0 1 10 20a9.596 9.596 0 0 1-4.527-1.103c-1.365-.704-2.443-1.663-3.233-2.878C1.413 14.772 1 13.43 1 11.99h2.263c0 1.088.301 2.09.903 3.01.602.92 1.42 1.647 2.452 2.182 1.033.536 2.16.804 3.382.804s2.349-.268 3.382-.804c1.033-.535 1.85-1.263 2.452-2.182.602-.92.903-1.922.903-3.01 0-1.087-.301-2.09-.903-3.01-.602-.918-1.42-1.646-2.452-2.181-1.033-.536-2.16-.804-3.382-.804v4.029L4.368 5.012 10 0v4.029z"
                                fill="#ffb200"
                              ></path>
                            </svg>
                          </button>
                        </div> */}

                        <div
                          className="px-[9px] py-[10px] relative bottom-px left-[2px] bg-[rgba(255,_255,_255,_.1)] text-[white] [box-shadow:inset_0_1px_0_0_rgba(255,_255,_255,_.4)] h-[9.33333vw] font-bold rounded-[5px] border-[1px] border-[solid] border-[#0b1933] justify-center items-center flex mr-[6px]"
                          onClick={() => navigate("/setting")}
                        >
                          <button
                            type="button"
                            className="text-[white] text-[20px] font-bold"
                          >
                            <svg
                              width="20"
                              height="20"
                              xmlns="http://www.w3.org/2000/svg"
                              xmlnsXlink="http://www.w3.org/1999/xlink"
                            >
                              <path
                                d="M10.488 13c.621 0 1.203-.16 1.744-.478a3.608 3.608 0 0 0 1.29-1.278A3.32 3.32 0 0 0 14 9.512c0-.621-.16-1.203-.478-1.744a3.578 3.578 0 0 0-1.29-1.29A3.382 3.382 0 0 0 10.488 6a3.32 3.32 0 0 0-1.732.478c-.534.318-.96.748-1.278 1.29A3.382 3.382 0 0 0 7 9.512c0 .621.16 1.198.478 1.732.318.534.744.96 1.278 1.278a3.32 3.32 0 0 0 1.732.478zm7.187-2.014l2.147 1.634c.099.08.157.184.173.313a.555.555 0 0 1-.074.36l-2.073 3.462a.448.448 0 0 1-.26.216.56.56 0 0 1-.357-.024l-2.542-.985c-.658.464-1.242.793-1.752.985l-.37 2.62a.607.607 0 0 1-.185.313.453.453 0 0 1-.309.12H7.927a.485.485 0 0 1-.469-.433l-.395-2.62c-.69-.272-1.267-.6-1.727-.985l-2.567.985c-.263.112-.469.048-.617-.192L.079 13.293a.555.555 0 0 1-.074-.36.464.464 0 0 1 .173-.313l2.171-1.634A7.323 7.323 0 0 1 2.3 10c0-.433.017-.761.05-.986L.177 7.38a.464.464 0 0 1-.173-.313.555.555 0 0 1 .074-.36l2.073-3.462c.148-.24.354-.304.617-.192l2.567.985a8.02 8.02 0 0 1 1.727-.985l.395-2.62A.485.485 0 0 1 7.927 0h4.146c.115 0 .218.04.309.12.09.08.152.184.185.313l.37 2.62c.641.24 1.226.569 1.752.985l2.542-.985a.56.56 0 0 1 .358-.024.448.448 0 0 1 .259.216l2.073 3.462c.066.112.09.232.074.36a.464.464 0 0 1-.173.313l-2.147 1.634c.033.225.05.553.05.986 0 .433-.017.761-.05.986z"
                                fill="#ffb200"
                              ></path>
                            </svg>
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </>
              )}
            </div>
          )}
        </div>
      </div>
    </>
  );
}

export default Header;
